import { render, staticRenderFns } from "./ElectricalMaintenanceApprove.vue?vue&type=template&id=a23e980e"
import script from "./ElectricalMaintenanceApprove.vue?vue&type=script&lang=js"
export * from "./ElectricalMaintenanceApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports